import React from 'react';

const AlgorithmDetails = ({ algorithmInfo, isLoadingAlgorithms }) => {
  // Safety check for algorithmInfo
  if (!algorithmInfo) {
    return (
      <div className="algorithm-details">
        <p>No algorithm information available</p>
      </div>
    );
  }

  return (
    <div className="algorithm-details">
      {isLoadingAlgorithms ? (
        <p>Loading algorithm information...</p>
      ) : (
        <>
          <h5>{algorithmInfo.name || 'Unknown Algorithm'}</h5>
          <p className="algorithm-description">{algorithmInfo.description || ''}</p>
          {algorithmInfo.principle && (
            <div className="algorithm-principle">
              <h6>Algorithm Principle:</h6>
              <p>{algorithmInfo.principle}</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AlgorithmDetails; 